<template>
	<component :is="indexModule.component" :foreingKey="indexModule.foreingKey" />
</template>
<style scoped>


</style>
<script>
	// import {
	// 	Loading
	// } from 'element-ui';
	import listBase from '@_system/components/base/list.vue'
	import loginMixins from '@_system/components/base/mixins/login/login.js'
	export default {
		mixins: [loginMixins],
		extends: listBase,
		props: {
			moduleConfig: {
				type: Object,
				default: () => {
					return {
						name: '',
						foreingKey: '{}',
						moduleName: '模块',
						device: window.systemMethods.device()
					}
				}
			},

		},
		data() {
			return {
				demoshow: true,
				key: Math.random(),
			}
		},
		watch: {

		},
		computed: {
			nameMap() {
				return this.$store.state.moduleMap
			},
		},
		created() {
			// this.loadhandle = Loading.service({
			// 	spinner: 'el-icon-loading',
			// 	text: '',
			// 	background: "rgba(255, 255, 255, 0.1)"
			// })
		},
		mounted() {
			if (!this.$store.state.system.systemdata) {
				this.login_init()
			} else {
				this.login_handle()
			}
		},
		methods: {
			login_after() {
				this.load()
			},
			load() {
				if (this.nameMap[this.moduleConfig.name]) {
					window.document.title = this.moduleConfig.moduleName
					this.init()
				} else {
					this.$emit('back', 'cancle')
					this.$message.error('模块路径不存在')
				}
			},
			initList() {

			},
			init() {
				import(`@/${this.nameMap[this.moduleConfig.name]}`).then((res) => {
					this.indexModule = {
						component: res.default,
						foreingKey: this.moduleConfig.foreingKey,
						device: this.moduleConfig.device
					}
				})
			}
		}
	}
</script>